import {CUSTOM_ELEMENTS_SCHEMA, NgModule} from '@angular/core';
import { CommonModule } from '@angular/common';
import {ToasterContainerComponent} from './toaster/toaster.container.component';
import {ToasterComponent} from "./toaster/toaster.component";

@NgModule({
  imports: [
    CommonModule,
  ],
  declarations: [ToasterComponent, ToasterContainerComponent],
  exports: [ToasterComponent, ToasterContainerComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class ToasterModule { }
